import classNames from 'classnames'
import { isEmpty, startCase } from 'lodash'
import { useNavigate } from 'react-router-dom'

type TProps = {
  firstName: string
  lastName: string
  email: string
  roles: string[]
  status: string
  id: string
}

const AccountsItem = ({ firstName, lastName, email, status, roles, id }: TProps) => {
  const navigate = useNavigate()

  const name =
    isEmpty(firstName) || isEmpty(lastName)
      ? 'unknown'
      : `${firstName ?? 'unknown'} ${lastName ?? 'unknown'}`

  const onClickItem = () => navigate(`/accounts/edit/${id}`)
  const displayRole = () => roles?.join(', ')

  const displayStatus = status === 'unconfirmed' ? 'Inactive' : startCase(status)

  return (
    <div className="item" onClick={onClickItem} role="button">
      <div className="row">
        <div className="item-info-wrapper">{name}</div>
        <div className="item-info-wrapper">
          <span className="-truncate-text-lg">{email}</span>
        </div>
        <div className="item-info-wrapper">{displayRole()}</div>
        <div className="item-info-wrapper">
          <span
            className={classNames('item-info-wrapper__dot', {
              '-success': status === 'active',
              '-error': status === 'unconfirmed',
              '-warning': status === 'invitation pending',
            })}
          ></span>
          {displayStatus}
        </div>
      </div>
    </div>
  )
}

export default AccountsItem
